import { useEffect, useState, useRef } from 'react';
import '../../assets/styles/_login.scss';

const XCallback = () => {
  const [statusMessage, setStatusMessage] = useState('جاري التحقق من حسابك...');
  const [error, setError] = useState('');
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    const codeVerifier = sessionStorage.getItem('x_code_verifier');
    const storedState = sessionStorage.getItem('x_oauth_state');

    const errorParam = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    const sendMessage = (type: string, data: any, closeDelay: number = 1000) => {
      Salla.event.emit('auth::social-media-login', { type, ...data });
      if (!window.opener) return;
      window.opener.postMessage({ type, ...data }, '*');
      setTimeout(() => window.close(), closeDelay);
    };

    // 1) لو فيه error من X
    if (errorParam) {
      const errorMsg = errorDescription
        ? `فشل تسجيل الدخول: ${errorDescription}`
        : `فشل تسجيل الدخول: ${errorParam}`;
      setStatusMessage('حدث خطأ');
      setError(errorMsg);
      sendMessage('X_LOGIN_ERROR', { error: { message: errorMsg } }, 3000);
      return;
    }

    // 2) لازم code
    if (!code) {
      const errorMsg = 'لم يتم استلام كود التفويض';
      setStatusMessage('حدث خطأ');
      setError(errorMsg);
      sendMessage('X_LOGIN_ERROR', { error: { message: errorMsg } }, 3000);
      return;
    }

    // 3) تحقق state لمنع CSRF
    if (!state || !storedState || state !== storedState) {
      const errorMsg = 'state غير متطابق، قد تكون محاولة CSRF';
      setStatusMessage('حدث خطأ');
      setError(errorMsg);
      sendMessage('X_LOGIN_ERROR', { error: { message: errorMsg } }, 3000);
      return;
    }

    // 4) لازم code_verifier لأننا نستخدم PKCE
    if (!codeVerifier) {
      const errorMsg = 'code_verifier مفقود';
      setStatusMessage('حدث خطأ');
      setError(errorMsg);
      sendMessage('X_LOGIN_ERROR', { error: { message: errorMsg } }, 3000);
      return;
    }

    // نجاح
    setStatusMessage('جاري إتمام تسجيل الدخول...');
    sendMessage(
      'X_LOGIN_SUCCESS',
      {
        code,
        provider: 'x',
        code_verifier: codeVerifier,
        state,
      },
      1000
    );
  }, []);

  return (
    <div className="google-callback-container">
      <div className="loading-container">
        {!error && <div className="spinner" />}
        <h2 className="status-message">{statusMessage}</h2>
        {error && (
          <div className="error-container">
            <div className="error">{error}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default XCallback;
